<template>
  <nav class="sidebar">
    <div class="sidebar-header cat1">
      <p>Curso</p>
      <h3>{{ curso.nome }}</h3>
      <div class="progresso">
        <p><strong>{{curso.progresso}}%</strong> concluído</p>
        <div class="progress">
          <div class="progress-bar" role="progressbar" :style="{ width: curso.progresso + '%' }" :aria-valuenow="curso.progresso" aria-valuemin="0"
              aria-valuemax="100"></div>
        </div>
        <div
          class="mt-3 div-certificado"
          id="div-certificado"
          v-if="this.curso.qntTopicos >= 1 && this.curso.emitirCertificado"
          v-b-tooltip.hover.bottom
          :title="tooltipTitle"
        >
          <a href="javascript:void(0)" id="btnCertificado" :class="classeBtnCertificado" @click="enviaCertificado"> Emitir o Certificado de conclusão</a>
        </div>
      </div>
      <div id="dismiss" class="d-block d-sm-none btn-dismiss" @click="toggleSideBar()">
        <i class="fas fa-chevron-left"></i>
      </div>
    </div>

    <menu-lateral-sala-aula :modulos="modulos" :curso="curso" />
  </nav>
</template>

<script>
import MenuLateralSalaAula from './MenuLateralSalaAula'
import CertificadoAPI from '@/api/certificado-api.js'
import Swal from 'sweetalert2'

export default {
  name: 'SalaAulaSideBar',
  components: { MenuLateralSalaAula },
  props: {
    modulos: Array,
    curso: Object
  },
  mounted () {
    let a = document.getElementById('btnCertificado')
    if (this.curso.progresso >= this.percentualCertificado) {
      a.classList.remove('disabled')
    }
  },
  computed: {
    percentualCertificado () {
      if (this.$configEmpresa.textosConfiguraveis.percentualCertificado) {
        return this.$configEmpresa.textosConfiguraveis.percentualCertificado
      } else {
        return 75
      }
    },
    classeBtnCertificado () {
      let classe = 'btn btn-certificado btn-primary'
      if (this.curso.progresso < this.percentualCertificado) {
        return classe + ' disabled'
      }
      return classe
    },
    tooltipTitle () {
      if (this.curso.progresso < this.percentualCertificado) {
        return 'Alcance ' + this.percentualCertificado + '% e ganhe o certificado de conclusão deste curso'
      }
      return ''
    }
  },
  methods: {
    toggleSideBar: function () {
      $('.sidebar').removeClass('active')
    },
    async enviaCertificado (event) {
      const loader = this.$loading.show()
      let params = {
        nomeCurso: this.curso.nome,
        progresso: this.curso.progresso,
        categoria: this.curso.categoria,
        questoes: this.curso.conteudo.certificado.questoes_curso,
        videos: this.curso.conteudo.certificado.videos_curso,
        horas: this.curso.conteudo.certificado.horas_curso,
        minutos: this.curso.conteudo.certificado.minutos_curso,
        coordenador: this.curso.coordenador,
        referencia: this.curso.referencia,
        idCurso: this.curso.idCurso,
        empresaId: process.env.VUE_APP_EMPRESA_REF,
        cargaHoraria: this.curso.cargaHoraria,
        modulos: this.modulos
      }
      try {
        let response = await CertificadoAPI.enviarCertificado(params)
        Swal.fire({
          icon: 'success',
          showCloseButton: true,
          html: response.status
        })
        loader.hide()
      } catch (e) {
        Swal.fire({
          icon: 'error',
          showCloseButton: true,
          html: 'Ocorreu um erro. Tente novamente.'
        })
        loader.hide()
      }
    }
  }
}
</script>

<style scoped>

</style>
